import { Component, DestroyRef, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet, Event } from '@angular/router';
import { filter, tap } from 'rxjs';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SubscriptionService } from './shared/services/subscriptions/subscription.service';

// Adding a timestamp will busting the filenames of the dist files and kill cache on the devices
console.log('Build timestamp:', new Date().toISOString());

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  private readonly subscription = inject(SubscriptionService);
  loading = true;

  constructor(
    private router: Router,
    private destroyRef: DestroyRef,
  ) {
    const bodyTag = document.body;
    bodyTag.classList.add('loaded');
    this.stopAppLoader();
    this.subscription.initialise();
  }

   /**
   * Stop the HTML Loader on navigationEnd
   */
   private stopAppLoader() {
    this.router.events
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        // we only want one NavigationEnd  event to filter through
        filter((event: Event) => event instanceof NavigationEnd),
        tap(() => {
          this.loading = false;
        }),
      ).subscribe();
  }
}